import { AdContentElement } from "./ad-content-element.model";

export class AdContent {
	materialId?: string;
	styleId?: string;
	preview?: string;

	columns?: number;
	depth?: number;
	width?: number;
	moduleLabel?: string;
	lines?: number;
	words?: number;

	adContentElements!: AdContentElement[];
}
